import { useState } from 'react';
import { Image } from 'react-bootstrap';
import { BsExclamationCircleFill, BsFillPatchCheckFill, BsPerson } from 'react-icons/bs';

export const Avatar = ({
  image,
  size = 30,
  className,
  enableIconStatus,
  isProfileComplete,
  ...rest
}: {
  image?: string | null;
  size?: number;
  className?: string;
  enableIconStatus?: boolean;
  isProfileComplete?: boolean;
}) => {
  const [hasError, setHasError] = useState(false);
  return (
    <div className={className}>
      <div className="position-relative d-inline-block">
        {image && !hasError ? (
          <Image
            alt="Profile picture"
            className="rounded-circle border border-1"
            src={image}
            width={size}
            height={size}
            onError={() => setHasError(true)}
            {...rest}
          />
        ) : (
          <div
            className="rounded-circle border border-1 d-inline-flex justify-content-center align-items-center"
            style={{ width: size, height: size }}
            {...rest}
          >
            <BsPerson size={size * 0.6} />
          </div>
        )}
        {enableIconStatus && (
          <>
            {!isProfileComplete && (
              <BsExclamationCircleFill
                size={32}
                className="profile-icon-status profile-icon-status--incomplete position-absolute rounded-circle"
              />
            )}
            {isProfileComplete && (
              <BsFillPatchCheckFill
                size={32}
                className="profile-icon-status profile-icon-status--complete position-absolute rounded-circle"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
